// extracted by mini-css-extract-plugin
export default {"container":"ClosureBanner_container__32Va7","title":"ClosureBanner_title__QRDM6","reason":"ClosureBanner_reason__vzDsu"};